import { ActionType } from '../constants/ActionTypes'
import config from '../constants/Configs'
import { RestPath } from '../constants/SitePaths'
import { Constants } from '../constants/Constants'
import { PopupEnum } from '../components/base/PopupEnum'
import axios from 'axios'
import CahceHelper, { CacheParam } from '../services/helpers/CahceHelper'


/* CONTROLS SETTINGS */
export const getControlsBegin = (data) => ({
    type: ActionType.GET_CONTROLS_BEGIN,
    payload: data
})

export const getControlsError = (data) => ({
    type: ActionType.GET_CONTROLS_ERROR,
    payload: data
});

export const getControlsSuccess = (data) => ({
    type: ActionType.GET_CONTROLS_SUCCESS,
    payload: data
})

export const changePopupVisibility = (data) => ({
    type: ActionType.CHANGE_POPUP_VISIBILITY,
    payload: data
})

export const resetAgentLogin = (data) => ({
    type: ActionType.RESET_AGENT_LOGIN,
    payload: data
})


export const changePopupVisibilityWithNoReset = (data) => ({
    type: ActionType.CHANGE_POPUP_VISIBILITY_NO_RESET,
    payload: data
})

export const resetPopupCallback = () => ({
    type: ActionType.RESET_POPUP_CALLBACK,
})

export const changeMyProfilePopupVisibility = (visibility, selectedTab, selectedSubTab) => ({
    type: ActionType.CHANGE_MY_PROFILE_POPUP_VISIBILITY,
    payload: { visibility: visibility, selectedTab: selectedTab, selectedSubTab: selectedSubTab }
})

export const changeMessagesPopupVisibility = (data) => ({
    type: ActionType.CHANGE_MESSAGES_POPUP_VISIBILITY,
    payload: data
})

export const changeFilterPopupVisibility = (data) => ({
    type: ActionType.CHANGE_FITER_POPUP_VISIBILITY,
    payload: data
})

export const changeMultiviewGrid = (data) => ({
    type: ActionType.CHANGE_MULTIVIEW_GRID,
    payload: data
})

export const resetPage = () => ({
    type: ActionType.RESET_PAGE
})

/* CONTROLS SETTINGS */

export function getControls(section, builderAction, w) {
    return dispatch => {

        dispatch(getControlsBegin(section));
        const cacheParams = CahceHelper.getUrlCacheParams();
        CahceHelper.addCacheParam(cacheParams, CacheParam.PLATFORM);
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CONTROLS,
            params: { topSection: section, ...cacheParams, w }
        }).then((response) => {
            dispatch(getControlsSuccess({ section: section, data: response.data }))
            builderAction && typeof (Event) === 'function' && window.dispatchEvent(new Event('resize'))
            return response.data
        }).catch((error) => {
                if (error.response) {
                    dispatch(getControlsError({ section, error: error.response.data }))
                } else {
                    dispatch(getControlsError({ section, error }))
                }
            })
    }
}

export function getOneClickRegistration(builderAction) {
    return dispatch => {
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_ONE_CLICK_REGISTRATION,
        }).then((response) => {
            builderAction && typeof (Event) === 'function' && window.dispatchEvent(new Event('resize'))
            return response.data
        })
            .catch((error) => {
                // NotificationService.error({ message: error.message });
            })
    }
}

export function closeProfileTabsPopup(ui) {
    return dispatch => {
        if (ui.popupVisible >= PopupEnum.MyProfile) {
            dispatch(changePopupVisibility(PopupEnum.Close))
        }
    };
}


// actions/UserActions.js or UIActions.js

export const setLastActiveMenu = (payload) => ({
    type: 'SET_LAST_ACTIVE_MENU',
    payload
  });
  
  export const resetLastActiveMenu = () => ({
    type: 'RESET_LAST_ACTIVE_MENU'
  });
  